import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrCancellationPolicyType.ts
var t = () => e("cancellationPolicyType");
//#endregion
export { t as useTrCancellationPolicyType };
